const CAPTCHA_RESET = "CAPTCHA_RESET";
const CAPTCHA_EXECUTE = "CAPTCHA_EXECUTE";

export { CAPTCHA_RESET, CAPTCHA_EXECUTE };
